/**
 * Created by yongkai on 2022/08/19.
 * 通用工具类
 */

/**
 * 全局业务appId
 * paas应用id saas业务线 生产环境: '15df4d3f', 测试环境: 'fd8d3653', 环境迁移新增测试环境: ''
 */
export const bu_appId = {
  test_new: 'f14ed109',
  test: 'fd8d3653',
  development: 'fd8d3653',
  production: '15df4d3f'
};
